'use strict'

import axios from 'axios'
import qs from 'qs'

axios.interceptors.request.use(config => {
  // loading

  // console.log("请求前做某些事")
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error.response)
})

function checkStatus (response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  // if (response && (response.data.status === 200 || response.data.status === 304 || response.data.status === 400)) {
  if (response && (response.data.status === 1)) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  // return {
  //   status: -404,
  //   msg: response.data.msg
  // }
  return response;
}

function checkCode (res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    console.log("错误信息："+res.msg)
  }
  if (res.data && (!res.data.success)) {
    console.log("错误信息2："+res.data.error_msg)
  }
  return res
}

const isPro = Object.is(process.env.NODE_ENV,'production')

export default {
  post (url, data) {
    return axios({
      method: 'post',
      // baseURL: 'http://119.23.151.23/',
      // baseURL: '/api',
      baseURL: 'https://app.chrp-org.com:8443/',
      // baseURL: 'https://10.29.255.75:8443/',
      url,
      data: qs.stringify(data),
      timeout: 1000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }).then(
      (response) => {
      	// console.log(response);
        return response;
      }
    ).catch(
      (res) => {
      	console.log("报错");
        return res;
      }
    )
  },
  get (url, params) {
    return axios({
      method: 'get',
      // baseURL: 'http://119.23.151.23/',
      // baseURL: '/api',
      baseURL: 'https://app.chrp-org.com:8443/',
      // baseURL: 'https://10.29.255.75:8443/',
      url,
      params, // get 请求时带的参数
      timeout: 1000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return response
      }
    ).catch(
      (res) => {
        return res
      }
    )
  }
}


// WEBPACK FOOTER //
// ./src/utils/api/axios.js